const optionsPartido = [{"value":0,"label":""},{"value":1,"label":"ADOLFO ALSINA"},{"value":51,"label":"ADOLFO GONZÁLES CHAVES"},{"value":2,"label":"ALBERTI"},{"value":3,"label":"ALMIRANTE BROWN"},{"value":10,"label":"ARRECIFES"},{"value":4,"label":"AVELLANEDA"},{"value":5,"label":"AYACUCHO"},{"value":6,"label":"AZUL"},{"value":7,"label":"BAHÍA BLANCA"},{"value":8,"label":"BALCARCE"},{"value":9,"label":"BARADERO"},{"value":53,"label":"BENITO JUÁREZ"},{"value":120,"label":"BERAZATEGUI"},{"value":114,"label":"BERISSO"},{"value":11,"label":"BOLÍVAR"},{"value":12,"label":"BRAGADO"},{"value":13,"label":"BRANDSEN"},{"value":14,"label":"CAMPANA"},{"value":15,"label":"CAÑUELAS"},{"value":121,"label":"CAPITÁN SARMIENTO"},{"value":16,"label":"CARLOS CASARES"},{"value":17,"label":"CARLOS TEJEDOR"},{"value":18,"label":"CARMEN DE ARECO"},{"value":20,"label":"CASTELLI"},{"value":26,"label":"CHACABUCO"},{"value":27,"label":"CHASCOMÚS"},{"value":28,"label":"CHIVILCOY"},{"value":21,"label":"COLÓN"},{"value":22,"label":"CORONEL DORREGO"},{"value":23,"label":"CORONEL PRINGLES"},{"value":113,"label":"CORONEL ROSALES"},{"value":24,"label":"CORONEL SUÁREZ"},{"value":19,"label":"DAIREAUX"},{"value":29,"label":"DOLORES"},{"value":115,"label":"ENSENADA"},{"value":118,"label":"ESCOBAR"},{"value":30,"label":"ESTEBAN ECHEVERRÍA"},{"value":31,"label":"EXALTACIÓN DE LA CRUZ"},{"value":130,"label":"EZEIZA"},{"value":32,"label":"FLORENCIO VARELA"},{"value":128,"label":"FLORENTINO AMEGHINO"},{"value":33,"label":"GENERAL ALVARADO"},{"value":34,"label":"GENERAL ALVEAR"},{"value":35,"label":"GENERAL ARENALES"},{"value":36,"label":"GENERAL BELGRANO"},{"value":37,"label":"GENERAL GUIDO"},{"value":40,"label":"GENERAL LA MADRID"},{"value":41,"label":"GENERAL LAS HERAS"},{"value":42,"label":"GENERAL LAVALLE"},{"value":39,"label":"GENERAL MADARIAGA"},{"value":43,"label":"GENERAL PAZ"},{"value":44,"label":"GENERAL PINTO"},{"value":45,"label":"GENERAL PUEYRREDÓN"},{"value":46,"label":"GENERAL RODRÍGUEZ"},{"value":47,"label":"GENERAL SAN MARTÍN"},{"value":49,"label":"GENERAL VIAMONTE"},{"value":50,"label":"GENERAL VILLEGAS"},{"value":52,"label":"GUAMINÍ"},{"value":119,"label":"HIPÓLITO YRIGOYEN"},{"value":135,"label":"HURLINGHAM"},{"value":136,"label":"ITUZAINGÓ"},{"value":132,"label":"JOSÉ C. PAZ"},{"value":54,"label":"JUNÍN"},{"value":123,"label":"LA COSTA"},{"value":70,"label":"LA MATANZA"},{"value":55,"label":"LA PLATA"},{"value":25,"label":"LANÚS"},{"value":56,"label":"LAPRIDA"},{"value":58,"label":"LAS FLORES"},{"value":59,"label":"LEANDRO N. ALEM"},{"value":137,"label":"LEZAMA"},{"value":60,"label":"LINCOLN"},{"value":61,"label":"LOBERÍA"},{"value":62,"label":"LOBOS"},{"value":63,"label":"LOMAS DE ZAMORA"},{"value":64,"label":"LUJÁN"},{"value":65,"label":"MAGDALENA"},{"value":66,"label":"MAIPÚ"},{"value":133,"label":"MALVINAS ARGENTINAS"},{"value":69,"label":"MAR CHIQUITA"},{"value":68,"label":"MARCOS PAZ"},{"value":71,"label":"MERCEDES"},{"value":72,"label":"MERLO"},{"value":73,"label":"MONTE"},{"value":126,"label":"MONTE HERMOSO"},{"value":74,"label":"MORENO"},{"value":101,"label":"MORÓN"},{"value":75,"label":"NAVARRO"},{"value":76,"label":"NECOCHEA"},{"value":77,"label":"NUEVE DE JULIO"},{"value":78,"label":"OLAVARRÍA"},{"value":79,"label":"PATAGONES"},{"value":80,"label":"PEHUAJÓ"},{"value":81,"label":"PELLEGRINI"},{"value":82,"label":"PERGAMINO"},{"value":83,"label":"PILA"},{"value":84,"label":"PILAR"},{"value":124,"label":"PINAMAR"},{"value":129,"label":"PRESIDENTE PERÓN"},{"value":85,"label":"PUAN"},{"value":134,"label":"PUNTA INDIO"},{"value":86,"label":"QUILMES"},{"value":87,"label":"RAMALLO"},{"value":88,"label":"RAUCH"},{"value":89,"label":"RIVADAVIA"},{"value":90,"label":"ROJAS"},{"value":91,"label":"ROQUE PÉREZ"},{"value":92,"label":"SAAVEDRA"},{"value":93,"label":"SALADILLO"},{"value":122,"label":"SALLIQUELÓ"},{"value":67,"label":"SALTO"},{"value":94,"label":"SAN ANDRÉS DE GILES"},{"value":95,"label":"SAN ANTONIO DE ARECO"},{"value":116,"label":"SAN CAYETANO"},{"value":96,"label":"SAN FERNANDO"},{"value":97,"label":"SAN ISIDRO"},{"value":131,"label":"SAN MIGUEL"},{"value":98,"label":"SAN NICOLÁS"},{"value":99,"label":"SAN PEDRO"},{"value":100,"label":"SAN VICENTE"},{"value":102,"label":"SUIPACHA"},{"value":103,"label":"TANDIL"},{"value":104,"label":"TAPALQUÉ"},{"value":57,"label":"TIGRE"},{"value":105,"label":"TORDILLO"},{"value":106,"label":"TORNQUIST"},{"value":107,"label":"TRENQUE LAUQUEN"},{"value":108,"label":"TRES ARROYOS"},{"value":117,"label":"TRES DE FEBRERO"},{"value":127,"label":"TRES LOMAS"},{"value":109,"label":"VEINTICINCO DE MAYO"},{"value":110,"label":"VICENTE LÓPEZ"},{"value":125,"label":"VILLA GESELL"},{"value":111,"label":"VILLARINO"},{"value":38,"label":"ZÁRATE"}];

const optionsRP2_Todos = [{"value":0,"label":"Todos"},{"value":1,"label":"ADOLFO ALSINA"},{"value":51,"label":"ADOLFO GONZÁLES CHAVES"},{"value":2,"label":"ALBERTI"},{"value":3,"label":"ALMIRANTE BROWN"},{"value":10,"label":"ARRECIFES"},{"value":4,"label":"AVELLANEDA"},{"value":5,"label":"AYACUCHO"},{"value":6,"label":"AZUL"},{"value":7,"label":"BAHÍA BLANCA"},{"value":8,"label":"BALCARCE"},{"value":9,"label":"BARADERO"},{"value":53,"label":"BENITO JUÁREZ"},{"value":120,"label":"BERAZATEGUI"},{"value":114,"label":"BERISSO"},{"value":11,"label":"BOLÍVAR"},{"value":12,"label":"BRAGADO"},{"value":13,"label":"BRANDSEN"},{"value":14,"label":"CAMPANA"},{"value":15,"label":"CAÑUELAS"},{"value":121,"label":"CAPITÁN SARMIENTO"},{"value":16,"label":"CARLOS CASARES"},{"value":17,"label":"CARLOS TEJEDOR"},{"value":18,"label":"CARMEN DE ARECO"},{"value":20,"label":"CASTELLI"},{"value":26,"label":"CHACABUCO"},{"value":27,"label":"CHASCOMÚS"},{"value":28,"label":"CHIVILCOY"},{"value":21,"label":"COLÓN"},{"value":22,"label":"CORONEL DORREGO"},{"value":23,"label":"CORONEL PRINGLES"},{"value":113,"label":"CORONEL ROSALES"},{"value":24,"label":"CORONEL SUÁREZ"},{"value":19,"label":"DAIREAUX"},{"value":29,"label":"DOLORES"},{"value":115,"label":"ENSENADA"},{"value":118,"label":"ESCOBAR"},{"value":30,"label":"ESTEBAN ECHEVERRÍA"},{"value":31,"label":"EXALTACIÓN DE LA CRUZ"},{"value":130,"label":"EZEIZA"},{"value":32,"label":"FLORENCIO VARELA"},{"value":128,"label":"FLORENTINO AMEGHINO"},{"value":33,"label":"GENERAL ALVARADO"},{"value":34,"label":"GENERAL ALVEAR"},{"value":35,"label":"GENERAL ARENALES"},{"value":36,"label":"GENERAL BELGRANO"},{"value":37,"label":"GENERAL GUIDO"},{"value":40,"label":"GENERAL LA MADRID"},{"value":41,"label":"GENERAL LAS HERAS"},{"value":42,"label":"GENERAL LAVALLE"},{"value":39,"label":"GENERAL MADARIAGA"},{"value":43,"label":"GENERAL PAZ"},{"value":44,"label":"GENERAL PINTO"},{"value":45,"label":"GENERAL PUEYRREDÓN"},{"value":46,"label":"GENERAL RODRÍGUEZ"},{"value":47,"label":"GENERAL SAN MARTÍN"},{"value":49,"label":"GENERAL VIAMONTE"},{"value":50,"label":"GENERAL VILLEGAS"},{"value":52,"label":"GUAMINÍ"},{"value":119,"label":"HIPÓLITO YRIGOYEN"},{"value":135,"label":"HURLINGHAM"},{"value":136,"label":"ITUZAINGÓ"},{"value":132,"label":"JOSÉ C. PAZ"},{"value":54,"label":"JUNÍN"},{"value":123,"label":"LA COSTA"},{"value":70,"label":"LA MATANZA"},{"value":55,"label":"LA PLATA"},{"value":25,"label":"LANÚS"},{"value":56,"label":"LAPRIDA"},{"value":58,"label":"LAS FLORES"},{"value":59,"label":"LEANDRO N. ALEM"},{"value":137,"label":"LEZAMA"},{"value":60,"label":"LINCOLN"},{"value":61,"label":"LOBERÍA"},{"value":62,"label":"LOBOS"},{"value":63,"label":"LOMAS DE ZAMORA"},{"value":64,"label":"LUJÁN"},{"value":65,"label":"MAGDALENA"},{"value":66,"label":"MAIPÚ"},{"value":133,"label":"MALVINAS ARGENTINAS"},{"value":69,"label":"MAR CHIQUITA"},{"value":68,"label":"MARCOS PAZ"},{"value":71,"label":"MERCEDES"},{"value":72,"label":"MERLO"},{"value":73,"label":"MONTE"},{"value":126,"label":"MONTE HERMOSO"},{"value":74,"label":"MORENO"},{"value":101,"label":"MORÓN"},{"value":75,"label":"NAVARRO"},{"value":76,"label":"NECOCHEA"},{"value":77,"label":"NUEVE DE JULIO"},{"value":78,"label":"OLAVARRÍA"},{"value":79,"label":"PATAGONES"},{"value":80,"label":"PEHUAJÓ"},{"value":81,"label":"PELLEGRINI"},{"value":82,"label":"PERGAMINO"},{"value":83,"label":"PILA"},{"value":84,"label":"PILAR"},{"value":124,"label":"PINAMAR"},{"value":129,"label":"PRESIDENTE PERÓN"},{"value":85,"label":"PUAN"},{"value":134,"label":"PUNTA INDIO"},{"value":86,"label":"QUILMES"},{"value":87,"label":"RAMALLO"},{"value":88,"label":"RAUCH"},{"value":89,"label":"RIVADAVIA"},{"value":90,"label":"ROJAS"},{"value":91,"label":"ROQUE PÉREZ"},{"value":92,"label":"SAAVEDRA"},{"value":93,"label":"SALADILLO"},{"value":122,"label":"SALLIQUELÓ"},{"value":67,"label":"SALTO"},{"value":94,"label":"SAN ANDRÉS DE GILES"},{"value":95,"label":"SAN ANTONIO DE ARECO"},{"value":116,"label":"SAN CAYETANO"},{"value":96,"label":"SAN FERNANDO"},{"value":97,"label":"SAN ISIDRO"},{"value":131,"label":"SAN MIGUEL"},{"value":98,"label":"SAN NICOLÁS"},{"value":99,"label":"SAN PEDRO"},{"value":100,"label":"SAN VICENTE"},{"value":102,"label":"SUIPACHA"},{"value":103,"label":"TANDIL"},{"value":104,"label":"TAPALQUÉ"},{"value":57,"label":"TIGRE"},{"value":105,"label":"TORDILLO"},{"value":106,"label":"TORNQUIST"},{"value":107,"label":"TRENQUE LAUQUEN"},{"value":108,"label":"TRES ARROYOS"},{"value":117,"label":"TRES DE FEBRERO"},{"value":127,"label":"TRES LOMAS"},{"value":109,"label":"VEINTICINCO DE MAYO"},{"value":110,"label":"VICENTE LÓPEZ"},{"value":125,"label":"VILLA GESELL"},{"value":111,"label":"VILLARINO"},{"value":38,"label":"ZÁRATE"}];

const optionsPrioritario=[
  { value:"TODOS", label:"Todos" },
  { value:"true", label:"Prioritario" },
  { value:"false", label:"No prioritario" },
];

const optionsResponsable = [
  { value: "", label:"" },
  { value: "PABLO GONZÁLEZ", label:"Pablo González" },
  { value: "LUCÍA MATTEUCCI", label: "Lucía Matteucci" },
  { value: "TERESITA ISLA", label: "Teresita Isla" },
  { value: "ALEXIS GOINHEX", label: "Alexis Goinhex" },
  { value: "NICOLÁS RESA", label: "Nicolás Resa" },
  { value: "RICARDO ALBINA", label: "Ricardo Albina" },
  { value: "ESTELA RETTA", label: "Estela Retta" },
  { value: "SILVANA SANTINÓN", label: "Silvana Santinón" },
  { value: "MANUEL KABUSACKI", label: "Manuel Kabusacki"},
  { value: "PABLO ETCHECHURY", label: "Pablo Etchechury"},
  { value: "ALEJANDRO BARREIRO", label: "Alejandro Barreiro"},
  { value: "LAURA MANDARANO", label: "Laura Mandarano"},
  { value: "AGUSTÍN MARTÍNEZ", label: "Agustín Martínez"},
  { value: "AGUSTINA MARIANO", label:"Agustina Mariano"},
  { value: "GABRIELA SOSA", label:"Gabriela Sosa"},
  { value: "IGNACIO LIGGERA", label:"Ignacio Liggera"},	
  { value: "AGUSTINA NIEVAS", label:"Agustina Nievas"}, //10-sep-2026: nuevo valor
  { value: "OTRO", label: "Otro" }
];

const optionsResponsable_Todos = [
  { value: "", label:"Todos" },
  { value: "PABLO GONZÁLEZ", label:"Pablo González" },
  { value: "LUCÍA MATTEUCCI", label: "Lucía Matteucci" },
  { value: "TERESITA ISLA", label: "Teresita Isla" },
  { value: "ALEXIS GOINHEX", label: "Alexis Goinhex" },
  { value: "NICOLÁS RESA", label: "Nicolás Resa" },
  { value: "RICARDO ALBINA", label: "Ricardo Albina" },
  { value: "ESTELA RETTA", label: "Estela Retta" },
  { value: "SILVANA SANTINÓN", label: "Silvana Santinón" },
  { value: "MANUEL KABUSACKI", label: "Manuel Kabusacki"},
  { value: "PABLO ETCHECHURY", label: "Pablo Etchechury"},
  { value: "ALEJANDRO BARREIRO", label: "Alejandro Barreiro"},
  { value: "LAURA MANDARANO", label: "Laura Mandarano"},
  { value: "AGUSTÍN MARTÍNEZ", label: "Agustín Martínez"},
  { value: "AGUSTINA MARIANO", label:"Agustina Mariano"},
  { value: "GABRIELA SOSA", label:"Gabriela Sosa"},
  { value: "IGNACIO LIGGERA", label:"Ignacio Liggera"},
  { value: "AGUSTINA NIEVAS", label:"Agustina Nievas"}, //10-sep-2026: nuevo valor
  { value: "OTRO", label: "Otro" }
];

const optionsPrograma = [
  { value:"", label: ""},
  { value:"LOTES CON SERVICIOS", label:"Lotes con Servicios" },
  { value:"PLAN FAMILIA PROPIETARIA", label:"Plan Familia Propietaria" },
  { value:"REGIMEN DE INTEGRACIÓN SOCIOURBANA", label:"Régimen de Integración Sociourbana" },
  { value:"LEY 14.461- PRO.CRE.AR", label: "Ley 14.461- Pro.Cre.Ar" } //nuevo valor 16-abr-2024
];
const optionsPrograma_Todos = [
  { value:"", label: "Todos"},
  { value:"LOTES CON SERVICIOS", label:"Lotes con Servicios" },
  { value:"PLAN FAMILIA PROPIETARIA", label:"Plan Familia Propietaria" },
  { value:"REGIMEN DE INTEGRACIÓN SOCIOURBANA", label:"Régimen de Integración Sociourbana" },
  { value:"LEY 14.461- PRO.CRE.AR", label: "Ley 14.461- Pro.Cre.Ar" } //nuevo valor 16-abr-2024
];

const optionsEstado = [
  { value:"", label:""},
  { value:"ANÁLISIS PRELIMINAR", label:"Análisis preliminar"}, //2-jun-2025: nuevo valor
  { value:"EN PROCESO", label:"En proceso"},
  //10-sep-2026: 'ANÁLISIS PRELIMINAR Y EN PROCESO' quitado - es solo filtro (agrupa 2 estados), NO elegible en carga/edicion
  { value:"AFECTADO CON RESOLUCIÓN", label:"Afectado con resolución"},
  { value:"RECTIFICADO", label:"Rectificado"},//nuevo valor 13-mar-2024
  { value:"OBSERVADO", label:"Observado"},
  { value:"INACTIVO", label:"Inactivo"},
  { value:"RECHAZADO", label:"Rechazado"},
  { value:"COMPRA ORIGINARIA", label:"Compra Originaria"}, //10-sep-2026: nuevo valor
  { value:"NO EJECUTADO", label:"No ejecutado"} //10-sep-2026: nuevo valor
];
const optionsEstado_Todos = [
  { value:"", label:"Todos"},
  { value:"ANÁLISIS PRELIMINAR", label:"Análisis preliminar"}, //2-jun-2025: nuevo valor
  { value:"EN PROCESO", label:"En proceso"},
  { value:"ANÁLISIS PRELIMINAR Y EN PROCESO", label:"Análisis preliminar y En proceso"}, //8-enero-2026: nuevo valor
  { value:"AFECTADO CON RESOLUCIÓN", label:"Afectado con resolución"},
  { value:"RECTIFICADO", label:"Rectificado"},//nuevo valor 13-mar-2024
  { value:"LOTES GENERADOS", label:"Lotes generados: afectados, rectificados y compra originaria"},//nuevo valor 13-mar-2024
  { value:"OBSERVADO", label:"Observado"},
  { value:"INACTIVO", label:"Inactivo"},
  { value:"RECHAZADO", label:"Rechazado"},
  { value:"COMPRA ORIGINARIA", label:"Compra Originaria"}, //10-sep-2026: nuevo valor
  { value:"NO EJECUTADO", label:"No ejecutado"} //10-sep-2026: nuevo valor
];

const optionsTipo = [
  {value: "", label: ""},
  {value: "INMUEBLES DEL ESTADO", label: "Inmuebles del Estado"},
  {value: "PROCESOS DE ORGANIZACION COLECTIVA", label: "Procesos de Organizacion Colectiva"},
  {value: "CONVENIO URBANÍSTICO", label: "Convenio Urbanístico"},
];

const optionsTipo_Todos = [
  {value: "", label: "Todos"},
  {value: "INMUEBLES DEL ESTADO", label: "Inmuebles del Estado"},
  {value: "PROCESOS DE ORGANIZACION COLECTIVA", label: "Procesos de Organizacion Colectiva"},
  {value: "CONVENIO URBANÍSTICO", label: "Convenio Urbanístico"},
];

const optionsTitular = [
  {value:"", label:""},
  {value:"MUNICIPIO", label:"Municipio"},
  {value:"PROVINCIA (IVBA u otros)", label:"Provincia (IVBA u otros)"},
  {value:"ESTADO NACIONAL", label:"Estado Nacional"},
  {value:"PRIVADOS PARTICULARES", label:"Privados Particulares"},
  {value:"PERSONA JURÍDICA CON FINES DE LUCRO", label:"Persona Jurídica con fines de Lucro"},
  {value:"COOPERATIVA", label:"Cooperativa"},
  {value:"ASOCIACIÓN CIVIL", label:"Asociación Civil"},
  {value:"SINDICATO", label:"Sindicato"},
  {value:"MUTUAL", label:"Mutual"},
  {value:"CONDOMINIO", label:"Condominio"},
  {value:"BANCO HIPOTECARIO", label:"Banco Hipotecario"},
  {value:"FONDO DE INTEGRACIÓN  SOCIOURBANA (FISU)", label:"Fondo de Integración Sociourbana (FISU)"}, //nuevo valor 16-abr-2024
  {value:"OTROS", label:"Otros"},
  {value:"SIN DATO", label:"Sin Dato"},

];

const optionsPlano = [
  {value:"", label:""},
  {value:"SI", label:"SI"},
  {value:"NO", label:"NO"}
];

const optionsArea = [
	{value:"", label:""},
	{value:"URBANA", label:"Urbana"},
	{value:"COMPLEMENTARIA", label:"Complementaria"},
	{value:"RURAL", label:"Rural"},
	{value:"OTRO", label:"otro"}
];

const optionsSistemaAgua = [
  {value:"", label:""},
  {value:"RED", label:"Red"}, //red //1
  {value:"SISTEMA CENTRALIZADO", label:"Sistema centralizado"}, //sistema_centralizado //2
  {value:"CAPTACIÓN SUBTERRÁNEA", label:"Captación subterránea"},//captacion_subterranea //3
  {value:"OTRO", label:"Otro"},//otro //4
  {value:"SIN DATO", label:"Sin dato"}//sin dato //5
];

const optionsEliminacionExcret = [
  {value:"", label:""},//
  {value:"RED", label:"Red"},//red_cloacal //1
  {value:"SISTEMA CENTRALIZADO", label:"Sistema centralizado"},//sistema_centralizado //2
  {value:"VUELCO", label:"Vuelco"},//vuelco //3
  {value:"OTRO", label:"Otro"},//otro //4
  {value:"SIN DATO", label:"Sin dato"},//sin_dato //5
];

// 1. Estado; 2. Mixto; 3. Desarrollo Privado; 4. Sin Desarrollo (consolidado); 5. Sin Dato
const optionsActorEncargadoObras = [
  {value:"", label:""},
  {value:"estado", label:"Estado"},
  {value:"mixto", label:"Mixto"},
  {value:"desarrollo privado", label:"Desarrollo Privado"},
  {value:"sin desarrollo (consolidado)", label:"Sin Desarrollo (consolidado)"},
  {value: "sin dato", label: "Sin Dato"}
];

const optionsSolicitado = [
	{value:"", label:""},
	{value:"sin solicitar", label:"Sin Solicitar"},
	{value:"solicitado", label:"Solicitado"},
	{value:"recibido", label:"Recibido"},
	{value:"observado", label:"Observado"}
];

const optionsJurisdiccionCSP = [
  {value:"", label:""},
  {value:"nacion", label:"Nación"},
  {value:"provincia", label:"Provincia"},
  {value:"municipio", label:"Municipio"}
];

//;;1. Sin iniciar; 2. En proceso; 3. Aprobado sin registrar; 4. Registrado; 5 Sin dato
const optionsEstadoTramitacionCSP = [
  {value:"", label:""},
  {value:"EN AGENDA", label:"En agenda"},
  {value:"MENSURA Y ANTEPROYECTO REALIZADOS", label:"Mensura y anteproyecto realizados"},
  {value:"SIN INICIAR", label:"Sin iniciar"},
  {value:"EN PROCESO", label:"En proceso"},
  {value:"APROBADO SIN REGISTRAR", label:"Aprobado sin registrar"},
  {value:"REGISTRADO", label:"Registrado"},
  {value:"Sin dato", label:"Sin dato"}
];

const optionsConsulta = [
  {value: "calcular_cantidad", label:"Calcular cantidad"},
  {value: "calcular_porcentaje", label:"Calcular porcentaje"}
];

//1. Solicitado/ 2. No Solicitado / 3. Recibido / 4. Falta documentación / 5. No Corresponde
const optionsTramitacionADA = [
  {value:"", label:""},
  {value:"solicitado", label:"Solicitado"},
  {value:"cargado para solicitar", label:"Cargado para solicitar"},
  {value:"recibido", label:"Recibido"},
  {value:"falta documentación", label:"Falta documentación"},
  {value:"no corresponde", label:"No corresponde"},
  {value:"solicitado por el municipio", label:"Solicitado por el municipio"}
];

const optionsTramitacionADA_Todos = [
  {value:"", label:"Todos"},
  {value:"solicitado", label:"Solicitado"},
  {value:"cargado para solicitar", label:"Cargado para solicitar"},//{value:"no solicitado", label:"No solicitado"},
  {value:"recibido", label:"Recibido"}
];

//1. Sin Iniciar / 2. En Proceso / 3. Finalizada
const optionsTramitacionResolucion = [
  {value:"", label:""},
  {value:"sin iniciar", label:"Sin iniciar"},
  {value:"en proceso", label:"En proceso"},
  {value:"finalizada", label:"Finalizada"}
]

//1.Si / 2.No / 3. Plano en elaboración / 4. Sin Dato
const optionsTramitacionVisado = [
  {value:"", label:""},
  {value:"Si", label:"Si"},
  {value:"No", label:"No"},
  {value:"Plano en elaboración", label:"Plano en elaboración"},
  {value:"Sin dato", label:"Sin dato"}
]

const optionsTramitacionVisado_Todos = [
  {value:"", label:"Todos"},
  {value:"Si", label:"Si"},
  {value:"No", label:"No"},
  {value:"Plano en elaboración", label:"Plano en elaboración"},
  {value:"Sin dato", label:"Sin dato"}
]

const optionsRegiones_todos = [
  {value:"", label:"Todas"},
  {value:"RMBA", label:"RMBA"},
  {value:"INTERIOR + 50 MIL HAB.", label:"INTERIOR + 50 MIL HAB."},
  {value:"INTERIOR - 50 MIL HAB.", label:"INTERIOR - 50 MIL HAB."},
]

const optionsSeguimientoCSP = [
  {value:"", label:""},
  {value:"Si", label:"Si"},
  {value:"No", label:"No"},
  {value:"No corresponde", label:"No corresponde"},
  {value:"Parcial", label: "Parcial"},
  {value:"Sin dato", label:"Sin dato"}
];

const optionsTramitacionCPU = [
  {value:"", label:""},
  {value:"Sin iniciar", label:"Sin iniciar"},
  {value:"En proceso", label:"En proceso"},
  {value:"Finalizada", label:"Finalizada"},
  {value:"No corresponde", label:"No corresponde"},
  {value:"Falta documentación" ,label:"Falta documentación"},
  {value:"Sin dato", label:"Sin dato"}
]

const optionsTramitacionCPU_Todos = [
  {value:"", label:"Todos"},
  {value:"Sin iniciar", label:"Sin iniciar"},
  {value:"En proceso", label:"En proceso"},
  {value:"Finalizada", label:"Finalizada"},
  {value:"No corresponde", label:"No corresponde"},
  {value:"Falta documentación" ,label:"Falta documentación"},
  {value:"Sin dato", label:"Sin dato"}
]

export {optionsRP2_Todos, optionsPrioritario,
  optionsPartido, optionsResponsable, optionsResponsable_Todos,
  optionsPrograma, optionsPrograma_Todos,
  optionsEstado, optionsEstado_Todos,
  optionsTipo, optionsTipo_Todos,
  optionsTitular,
  optionsPlano, optionsArea,
  optionsSistemaAgua, optionsEliminacionExcret,
  optionsActorEncargadoObras, optionsSolicitado,
  optionsJurisdiccionCSP, optionsEstadoTramitacionCSP,
  optionsConsulta,
  optionsTramitacionADA, optionsTramitacionADA_Todos,
  optionsTramitacionResolucion,
  optionsTramitacionVisado, optionsTramitacionVisado_Todos,
  optionsRegiones_todos,
  optionsSeguimientoCSP,
  optionsTramitacionCPU, optionsTramitacionCPU_Todos
};
